module.exports = __webpack_public_path__ + "img/donante-immujer.f10d5272.png";